import { Show } from '@pankod/refine-antd';

export const MakeProductShow: React.FC = () => {
  return <Show>Show Page</Show>;
};
